var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg239(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 10.8158V1.40279C40 1.09846 39.7529 0.854218 39.4494 0.854218H30.001C24.4771 0.854218 20 5.31454 20 10.8177C20 5.31454 15.5229 0.854218 9.99903 0.854218H0.550637C0.24516 0.854218 0 1.1004 0 1.40279V10.8158C0 16.319 4.47709 20.7793 10.001 20.7793C4.47709 20.7793 0 25.2396 0 30.7428V40.1558C0 40.4602 0.247106 40.7044 0.550637 40.7044H9.99903C15.5229 40.7044 20 36.2441 20 30.7409C20 36.2441 24.4771 40.7044 30.001 40.7044H39.4494C39.7548 40.7044 40 40.4582 40 40.1558V30.7428C40 25.2396 35.5229 20.7793 29.999 20.7793C35.5229 20.7793 40 16.319 40 10.8158ZM20 30.7409C20 25.2377 15.5229 20.7774 9.99903 20.7774C15.5229 20.7774 20 16.317 20 10.8139C20 16.317 24.4771 20.7774 30.001 20.7774C24.4771 20.7774 20 25.2377 20 30.7409Z",
    fill: "#C3A5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg239);
export default __webpack_public_path__ + "static/media/_239.d2a7464e8e8bf388ad2e4648c60dedeb.svg";
export { ForwardRef as ReactComponent };